import performRequest from "../config/AxiosConfig";

export const sendEmail = async (body) => {
  let res = await performRequest("/emails", "POST", body);
  return res;
};
